import { AssetCreationName, AssetCreationToolName, GenerationInstrument } from '@/types/media';
import { creditsBillingService, CreditsPriceItem, Modifier } from './CreditsBillingService';
import { MediaAssetToolsPrices } from './MediaAssetToolsPrices';
import { MediaAssetPrices } from './MediaAssetPrices';

export class PricesService {
  public static getPrice(
    name: AssetCreationToolName | AssetCreationName,
    instrumentsUsed: GenerationInstrument[] = [],
    count: number = 1,
    modifiers?: Modifier[]
  ): number {
    const priceItems = this.getPriceItems(name, instrumentsUsed);
    return this.calculatePrice(priceItems, modifiers) * count;
  }

  public static getPriceText(
    name: AssetCreationToolName | AssetCreationName,
    instrumentsUsed: GenerationInstrument[] = [],
    count: number = 1,
    modifiers?: Modifier[]
  ): string {
    const amount = this.getPrice(name, instrumentsUsed, count, modifiers);

    if (!amount) return '';
    if (amount === 1) return '1 credit';
    return `${amount} credits`;
  }

  private static getPriceItems(
    name: AssetCreationToolName | AssetCreationName,
    instrumentsUsed: GenerationInstrument[]
  ): CreditsPriceItem[] {
    if (MediaAssetToolsPrices.isToolName(name)) {
      return MediaAssetToolsPrices.getPriceItems(name as AssetCreationToolName, instrumentsUsed);
    }

    if (MediaAssetPrices.isMediaAsset(name)) {
      return MediaAssetPrices.getPriceItems(name as AssetCreationName);
    }

    return [];
  }

  private static calculatePrice(priceItems: CreditsPriceItem[], modifiers?: Modifier[]): number {
    return creditsBillingService.getAmount(priceItems, modifiers);
  }
}
